import React, { createContext, useContext, useState, useEffect } from 'react';
import pb from '../lib/pocketbase';

const HighlightsContext = createContext();

export const useHighlightsData = () => {
    return useContext(HighlightsContext);
};

export const HighlightsProvider = ({ children }) => {
    const [highlights, setHighlights] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchHighlights = async () => {
        try {
            setLoading(true);
            const records = await pb.collection('home_highlights').getFullList({
                sort: 'order',
            });
            setHighlights(records);
        } catch (error) {
            console.error('Error fetching highlights:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchHighlights();

        // Real-time subscription
        pb.collection('home_highlights').subscribe('*', (e) => {
            if (e.action === 'create') {
                setHighlights(prev => [...prev, e.record].sort((a, b) => a.order - b.order));
            } else if (e.action === 'delete') {
                setHighlights(prev => prev.filter(item => item.id !== e.record.id));
            } else if (e.action === 'update') {
                setHighlights(prev => prev.map(item => item.id === e.record.id ? e.record : item).sort((a, b) => a.order - b.order));
            }
        });

        return () => {
            pb.collection('home_highlights').unsubscribe('*');
        };
    }, []);

    const value = {
        highlights,
        loading,
        refresh: fetchHighlights
    };

    return (
        <HighlightsContext.Provider value={value}>
            {children}
        </HighlightsContext.Provider>
    );
};
